import { AlertProps } from '@mui/material/Alert';
import { SnackbarOrigin } from '@mui/material/Snackbar';

export interface SnackbarMessage extends AlertProps {
  id: string;
  title?: string;
  message: string;
  autoHideDuration?: number;
  action?: React.ReactNode;
  anchorOrigin?: SnackbarOrigin;
}

export interface SnackbarProviderProps {
  children: React.ReactNode;
  anchorOrigin?: SnackbarOrigin;
  autoHideDuration?: number;
  maxStack?: number;
}

export interface SnackbarContextType {
  showSnackbar: (message: Omit<SnackbarMessage, 'id'>) => void;
  hideSnackbar: (id: string) => void;
  clearAll: () => void;
}

export const DEFAULT_ANCHOR_ORIGIN: SnackbarOrigin = {
  vertical: 'top',
  horizontal: 'center',
};

export const DEFAULT_AUTO_HIDE_DURATION = 3500;
